interface CompPresentationConfig {
  type: 'Active Lease Deal'
    | 'Lease'
    | 'Land Sale'
    | 'Building Sale'
    | 'Utility'
    | 'Utilities'
    | 'Capital'
    | 'Portfolio'
    | 'Compliance Requirements'
    | 'Zoning';
  name: string;
  shortName: string;
  pluralizedName: string;
  dropdownLabel: string;
  placeholder: string;
  icon: string;
  visibility: string;
}

const COMP_TYPES: Map<string, CompPresentationConfig> = new Map([
  ['Active Lease Deal',
    {
      type: 'Active Lease Deal',
      name: 'Active Lease Deal',
      shortName: 'Lease Deal',
      pluralizedName: process.env.VUE_APP_FLAVOR === 'internal' ? 'Active Lease Deals' : 'Lease Deals',
      dropdownLabel: '',
      placeholder: 'Lease Deal Name',
      icon: '',
      visibility: '',
    },
  ],
  ['Lease',
    {
      type: 'Lease',
      name: 'Lease',
      shortName: 'Lease',
      pluralizedName: 'Leases',
      dropdownLabel: '',
      placeholder: 'Tenant',
      icon: '',
      visibility: '',
    },
  ],
  ['Land Sale',
    {
      type: 'Land Sale',
      name: 'Land Sale',
      shortName: 'Land Sale',
      pluralizedName: 'Land Sales',
      dropdownLabel: '',
      placeholder: 'Sale Date (i.e. May 2020)',
      icon: '',
      visibility: '',
    },
  ],
  ['Building Sale',
    {
      type: 'Building Sale',
      name: 'Building Sale',
      shortName: 'Bldg Sale',
      pluralizedName: 'Bldg Sales',
      dropdownLabel: '',
      placeholder: 'Sale Date (i.e. May 2020)',
      icon: '',
      visibility: '',
    },
  ],
  ['Utility',
    {
      type: 'Utility',
      name: 'Utility',
      shortName: 'Utilities',
      pluralizedName: 'Utilities',
      dropdownLabel: '',
      placeholder: 'Utility Name',
      icon: '',
      visibility: '',
    },
  ],
  // HACK: Temporary fix for old shared maps that used the type 'Utility' instead of 'Utilities' for
  // comps. This remapping logic ensures backward compatibility with older data.
  ['Utilities',
    {
      type: 'Utilities',
      name: 'Utility',
      shortName: 'Utilities',
      pluralizedName: 'Utilities',
      dropdownLabel: '',
      placeholder: 'Utility Name',
      icon: '',
      visibility: '',
    },
  ],
  ['Capital',
    {
      type: 'Capital',
      name: 'Capital',
      shortName: 'Capital',
      pluralizedName: 'Capital', // Capital is uncountable, so pluralized name is the same as singular
      dropdownLabel: '',
      placeholder: 'Investment Name',
      icon: '',
      visibility: '',
    },
  ],
  ['Portfolio',
    {
      type: 'Portfolio',
      name: 'Portfolio',
      shortName: '',
      pluralizedName: 'Portfolios',
      dropdownLabel: '',
      placeholder: 'Portfolio Name',
      icon: 'mdi-link-plus',
      visibility: '',
    },
  ],
  [
    'Place Marker',
    {
      type: 'placeMarker',
      name: 'Place Marker',
      shortName: 'Place Marker',
      pluralizedName: 'Place Markers',
      dropdownLabel: '',
      placeholder: 'Marker Name',
      icon: '',
      visibility: '',
    },
  ],
  ['Compliance Requirements',
    {
      type: 'Compliance Requirements',
      name: 'Compliance Requirements',
      shortName: 'Compliance',
      pluralizedName: 'Compliance Requirements',
      dropdownLabel: '',
      placeholder: 'Compliance Requirement',
      icon: '',
      visibility: '',
    },
  ],
  ['Zoning',
    {
      type: 'Zoning',
      name: 'Zoning',
      shortName: 'Zoning',
      pluralizedName: 'Zoning',
      dropdownLabel: '',
      placeholder: 'Zoning Code',
      icon: '',
      visibility: '',
    },
  ],
]);

const compTypeKeys = Array.from(COMP_TYPES.keys());

export {COMP_TYPES, CompPresentationConfig, compTypeKeys};
